import { createSelector } from 'reselect';

import { createKeySelector } from 'Lib/reduxUtils';

export const selectPhotos = createKeySelector('photos');

export const getIsReplacePhoto = createSelector(selectPhotos, (photos) => photos.isReplacePhoto);

export const getProfileInstagram = createSelector(selectPhotos, (photos) => photos.instagram);

export const getHasInstagram = createSelector(
  selectPhotos,
  (photos) => !!photos?.instagram?.username
);

export const getInstagramUserName = createSelector(
  selectPhotos,
  (photos) => photos?.instagram?.username
);

export const getShouldInstagramReauth = createSelector(
  selectPhotos,
  (photos) => photos?.instagram?.should_reauthenticate
);

export const getInstagramOAuthUrl = createSelector(
  selectPhotos,
  (photos) => photos?.instagram?.oAuthUrl
);
